import * as React from 'react';
import * as vars from '../../../consts/variables';
import { IWaypoint } from './MapboxMap';

const styles: Record<string, React.CSSProperties> = {
    icon: {
        position: 'relative',
        alignSelf: 'center',
    },
    flag: {
        width: 50,
        height: 50,
        color: vars.white,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        alignSelf: 'center',
        opacity: 1,
        fontSize: 12,
    },
};

interface Props extends IWaypoint {
    index: number;
    lat: number;
    lng: number;
    zoom: number;
    color?: string;
    city?: string;
    first?: boolean;
}

const ZOOM_DETAIL = 6;
export function MapMarker(props: Props) {
    return <div className="marker-html_pin number">{props.index}</div>;
}
